import React from "react";
import {
    Col,
    Row,
    Modal,
    ModalBody,
    ModalHeader,
    ModalFooter,
    Card,
    CardBody
} from "reactstrap";

const ImageCard = ({ img,toggleAddHandler }) => {
    return (
        <Col md={3} className="m-0 "    >
            <Row>
                <Col md={12} style={{ width: "100%", height: "70px" }}>
                    <img src={img.path} style={{ width: "100%", height: "100%" }} />
                </Col>
            </Row>
            <Row>
            <Col md={12} style={{ width: "100%", height: "20px",textAlign:"left" }} className="d-flex justify-content-between">
                <p className="my-2 font-size-16">{img.isInteract ? "Exist" : "Not Exist"}</p>
                <p className="my-2 font-size-16 " style={{cursor:"pointer"}} onClick={()=>toggleAddHandler(img)}>{img.isInteract ?
                 <p className="bg-danger px-1" >-</p> 
                 :
                  <p className="bg-success px-1" >+</p>
                }</p>

            </Col>
            </Row>
        </Col>
    )
}
const UploadImage = ({ modal, setModal, images ,toggleAddHandler }) => {
    return (
        <Modal isOpen={modal} toggle={() => setModal(false)}>
            <ModalHeader toggle={() => setModal(false)}>
                select images to add it to your interactive mode
              </ModalHeader >
            <ModalBody className="mb-4">
                <Row>
                    {images.map((img, index) => {
                        return <ImageCard img={img} key={index} toggleAddHandler={toggleAddHandler} />
                    })}
                </Row>
            </ModalBody>
            <ModalFooter className="d-flex justify-content-between">
                <Col md={12} className="parent-div my-4" >
                    <button type="button" onClick={()=>setModal(false)} className="btn btn-success px-4 w-100 btn-upload ">Close</button>
                </Col>
            </ModalFooter>
        </Modal>
    )
}
export default UploadImage